import { createFileRoute } from "@tanstack/react-router";

import { StudentEventScreen } from "@/interactors/StudentEventScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

const RouteComponent = () => {
  return (
    <div className="w-full self-center pt-5 md:max-w-[740px]">
      <StudentEventScreen />
    </div>
  );
};

export const Route = createFileRoute("/_authed/student/")({
  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "list",
      subject: "events",
    }),
  component: RouteComponent,
  head: () => headWithCustomTitle("main:events.title"),
});
